import React, { useState, useEffect } from 'react';
import { navigate } from '../utils/navigation';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import PrintHeader from '../components/PrintHeader';
import PrintFooter from '../components/PrintFooter';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';

const VerifySheet = () => {
  const { user } = useAuth();
  const [year, setYear] = useState('');
  const [docNumber, setDocNumber] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.getElementById('YEAR')?.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!year || !docNumber) {
      setError('برجاء إدخال رقم الاستمارة');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get('/public/search/user', {
        params: { year, docNumber }
      });

      if (response.data.success) {
        navigate(`/prenup/PreMarriageSheet/PrintSheet?SHEETID=${response.data.data.sheetId}`);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setError('لا يوجد بيانات');
      } else {
        setError('حدث خطأ ما');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-dashboard">
      <style dangerouslySetInnerHTML={{__html: `
        .text-danger {
            font-weight: bold;
            font-size: 18px;
        }

        .textboxes {
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;
        }
            .textboxes .input-one {
                width: 111px;
                margin: 0 10px;
            }
            .textboxes .input-two {
                width: 220px;
                margin: 0 10px;
            }
            @media (max-width: 768px) {
                .textboxes .input-one {
                    width: 90px;
                    margin: 0 5px;
                }

                .textboxes .input-two {
                    width: 200px;
                    margin: 0 5px;
                }
            }
      `}} />

      {/* Show Header for logged-in users, PrintHeader for public visitors */}
      {user ? <Header /> : <PrintHeader />}

      <main role="main">
        <div>
          <header className="bg-header small-header"></header>

          <div className="container mt-5" id="TableDiv">
            <div className="container mt-5 text-center">
              <h3>ادخل رقم الاستمارة</h3>
              <form onSubmit={handleSubmit}>
                <div className="row text-center mt-4 textboxes">
                  <div className="text-center input-one">
                    <input 
                      id="YEAR" 
                      type="text" 
                      className="form-control text-center" 
                      maxLength="4"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                  <div className="text-center" >
                    <p className="verify-sheet-large-dash">-</p>
                  </div>
                  <div className="text-center input-two">
                    <input 
                      id="DOCNUMBER" 
                      type="text" 
                      className="form-control text-center" 
                      maxLength="8"
                      value={docNumber}
                      onChange={(e) => setDocNumber(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </div>
             
                {error && (
                  <div className="text-danger mt-3">{error}</div>
                )}
                <br />
                <button 
                  className="btn btn-info" 
                  type="submit" 
                  disabled={loading}
                >
                  {loading ? 'جاري البحث...' : 'إدخال'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>

      <PrintFooter />

      {/* Loading overlay */}
      <div className="load"></div>
    </div>
  );
};

export default VerifySheet;